// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"03ab8cdd","498":"85fb596e","703":"80debd3d"}[chunkId] + ".chunk.js";
};